<template>
    <div>
        <el-card>
            <div class="tableBox">
                <div>
                    <div>
                        <span>变更统计</span>
                        <span>紧急变更统计</span>
                    </div>
                    <img src="../../../../assets/icon_logo.png">
                </div>
                <div>
                    <div>
                        <div style="position:relative;height:20px;">
                            <div class="helpDiv" style="position: absolute;top:-20px">
                                <b class="helpI"></b>
                                <a href="https://wiki.autoai.com/pages/viewpage.action?pageId=26156948"
                                target="_blank"
                                class="helpA">
                                    帮助指引
                                </a>
                            </div>
                        </div>
                        <!-- <el-form :inline="true" class="search-form">
                            <el-form-item label="">
                                <el-date-picker
                                    ref="dataPicker"
                                    @change="changeData"
                                    v-model="value"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-button type="primary" @click="selectData">修改时间</el-button>
                            <el-button type="primary" @click="exportTable('变更结果统计',value[0],`—${value[1]}`)">导出excel</el-button>
                        </el-form>  -->
                    </div>
                    <div class="tableClass">
                        <div>
                            <span>日期:</span>
                            <el-date-picker
                                ref="dataPicker"
                                @change="changeData"
                                v-model="value"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                            <el-table
                                :data="tableData"
                                show-summary
                                :summary-method="getSummaries" id="out_export">
                                <el-table-column width="80" prop="serialNumber" label="编号" sortable :sort-orders="sortList"></el-table-column>
                                <el-table-column prop="title" label="标题" ></el-table-column>
                                <el-table-column prop="projectName" label="项目"></el-table-column>
                                <el-table-column prop="create_time" label="创建时间"  :sort-orders="sortList"></el-table-column>
                            </el-table>
                        </div>
                        <!-- <div ref="myChart"></div> -->
                        <div>
                            <span>年:</span>
                            <el-date-picker
                              v-model="change_year"
                              type="year"
                              @change="changeYearEvent"
                              placeholder="选择年"
                              value-format="yyyy">
                            </el-date-picker>
                            <div class="chartDiv" ref="myChart"></div>
                        </div>

                    </div>
                </div>
                <div>
                    <div>
                        <span>生成时间:</span>
                        <span>{{getMes.generateTime}}</span>
                    </div>
                    <span>itsmops.autoai.com</span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    import services from '../report.service';
    import { export_json_to_excel } from '../../../../core/utils/Export2Excel';
    export default {
        data: function () {
            return {
                tableData: [],
                sortList:['descending', 'ascending'],
                value:[],
                change_year:null,
                options:{
                    tooltip: {
                        trigger: 'axis',
                        formatter: '数量: {c}<br/>'
                    },
                    xAxis: {
                        type: 'category',
                        name:'月份',
                        data: []
                    },
                    yAxis: {
                        type: 'value',
                        name:'数量',
                        minInterval: 5
                    },
                    series: [
                        {
                          data: [0, 10, 0, 0, 0],
                          type: 'line',
                          markLine: {
                            // data: [{ type: 'average', name: 'Avg' }]
                            data:[{name: 'Y 轴值为 5 的水平线', yAxis: 5}]
                          },
                          smooth: true
                        }
                    ]
                },
                getMes:{},
            }
        },
        // watch: {
        //     options: {
        //     // 数据变化时执行的逻辑代码
        //     handler(newdata, olddata) {
        //         this.options = newdata
        //     },
        //     // 开启深度监听
        //     deep: true
        //     }
        // },
        mounted(){
            this.value = services.getDefaultData();
            this.change_year = new Date().getFullYear()+'';
            this.getData();
            this.getEcharts()
        },
        methods:{
            // exportTable(name,startTime,endTime=''){
            //     this.$exportTable(name,startTime,endTime)
            // },

            // formatJson(filterVal, jsonData) {
            //     return jsonData.map(v => filterVal.map(j => v[j]))
            // },
            getData(){//获取数据
                let params = {
                    startTime: this.value[0],
                    stopTime: this.value[1],
                    // group:'changeManager',
                }
                services.getUrgentChangeTable(params).then(res=>{
                    this.tableData = res.tableData;
                })
            },
            // selectData(){//点击修改日期 日期控件自动聚焦
            //     let selData = this.$refs.dataPicker;
            //     selData.focus();
            // },
            changeData(){//选择日期
                this.getData();
            },
            changeYearEvent(val){
                this.getEcharts()
            },
            getEcharts(){//实例化图标
                let labarr=[]
                let valarr=[]
                services.getUrgentChangeChart({change_year:this.change_year}).then(res=>{
                    this.getMes.generateTime = res.generateTime;
                    // console.log(res.praghData[0][0])
                    res.praghData.forEach(item=>{
                        labarr.push(item[0])
                        valarr.push(item[1])
                    })
                    // this.options.xAxis.data = ['01','02','03','04','05'];
                    this.options.xAxis.data =labarr
                    this.options.series[0].data = valarr;
                    this.initChartEvent()
                })


            },
            initChartEvent(){
                // console.log(this.options)
                let myChart = this.$echarts.init(this.$refs.myChart);
                myChart.setOption(this.options);
            },

            //处理表格合计行的百分比数据
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];       //sums数组里的每一项对应合计行的每一列
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    // const values = data.map(item => Number(item[column.property]));
                    // sums[index] = values.reduce((prev, curr) => {
                    //     const value = Number(curr);
                    //     if (!isNaN(value)) {
                    //         return prev + curr;
                    //     } else {
                    //         return prev;
                    //     }
                    // }, 0);
                });
                // console.log(sums);
                // if (sums[1]==0&&sums[2]==0){
                //     sums[3]=0+'%'
                //     sums[4]=0+'%'
                // } else{
                //     sums[3]=((sums[1]/(sums[1]+sums[2]))*100).toFixed(0)+'%'
                //     sums[4]=((sums[2]/(sums[1]+sums[2]))*100).toFixed(0)+'%'
                // }
                sums[1]=this.tableData.length
                return sums;
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .tableClass{
        display: flex;
        &>div:nth-child(1){
            width: 50%;
        }
        &>div:nth-child(2){
            width: 50%;
            height:400px;
            .chartDiv{
                width: 100%;
                height:400px;
            }
        }
    }
</style>
